"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var EvaTable_1 = __importDefault(require("@/react-app/common/components/EvaTable"));
var TablePagination_1 = __importDefault(require("@/react-app/common/components/EvaTable/TablePagination"));
var HasError_1 = __importDefault(require("@/react-app/common/components/HasError"));
var Loading_1 = __importDefault(require("@/react-app/common/components/Loading"));
var ConfirmDelete_1 = __importDefault(require("@/react-app/common/components/Modal/ConfirmDelete"));
var NoData_1 = __importDefault(require("@/react-app/common/components/NoData"));
var NoResults_1 = __importDefault(require("@/react-app/common/components/NoResults"));
var SearchInput_1 = __importDefault(require("@/react-app/common/components/SearchInput"));
var TablePageHeader_1 = __importDefault(require("@/react-app/common/components/TablePageHeader"));
var store_1 = require("@/redux/store");
var Columns_1 = require("./Columns");
var constants_1 = require("./constants");
var dictionarySlice_1 = require("./state/dictionarySlice");
var string_1 = require("@/react-app/common/utils/string");
function default_1(_a) {
    var domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, currentUser = _a.currentUser;
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, store_1.useAppDispatch)();
    var dictionaries = (0, react_redux_1.useSelector)(dictionarySlice_1.dictionariesSelector);
    var isLoading = (0, react_redux_1.useSelector)(dictionarySlice_1.isLoadingSelector);
    var error = (0, react_redux_1.useSelector)(dictionarySlice_1.dictionariesErrorSelector);
    var _b = __read((0, react_1.useState)(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = __read((0, react_1.useState)(''), 2), searchText = _c[0], setSearchText = _c[1];
    var _d = __read((0, react_1.useState)(1), 2), page = _d[0], setPage = _d[1];
    var _e = __read((0, react_1.useState)(), 2), selectedDictionaryToRemove = _e[0], setSelectedDictionaryToRemove = _e[1];
    var transformedDictionaries = dictionaries.map(function (item) {
        var _a;
        return (__assign(__assign({}, item), { nameSort: (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase(), displayKind: (0, string_1.upperCaseFirstLetter)(item.kind) }));
    });
    var filteredDictionaries = transformedDictionaries.filter(function (item) {
        return constants_1.searchFields.some(function (field) { var _a; return (field ? (_a = item[field]) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.toLowerCase()) : ''); });
    });
    var totalCount = filteredDictionaries.length;
    var editHref = function (row) {
        return angularJsDependencies.href('app.assignment.automation.dictionaryEdit', {
            domain: domain,
            name: row.name,
        });
    };
    var createHref = angularJsDependencies.href('app.assignment.automation.dictionaryCreate', {
        domain: domain,
    });
    var columnRenderer = function (row, column, index) {
        switch (column) {
            case 'nameSort':
                return react_1.default.createElement(Columns_1.NameSortColumn, { row: row, editHref: editHref, key: index });
            case 'createdTime':
            case 'lastModifiedTime':
                return react_1.default.createElement(Columns_1.TimeColumn, { row: row, editHref: editHref, column: column, key: index });
            case 'lastModifiedBy':
            case 'displayKind':
                return react_1.default.createElement(Columns_1.DefaultColumn, { row: row, editHref: editHref, key: index, column: column });
            default:
                return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    var handleSearchInput = function (event) {
        setSearchText(event.target.value);
        setPage(1);
    };
    (0, react_1.useEffect)(function () {
        dispatch((0, dictionarySlice_1.getDictionaries)({ domain: domain, kind: 'confusable,mixed' }));
    }, [domain]);
    var total = filteredDictionaries.length;
    var noData = total === 0 && searchText.length === 0 && !error && !isLoading;
    var noResults = total === 0 && searchText.length > 0 && !error && !isLoading;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TablePageHeader_1.default, { href: createHref, title: t('AUTOMATION.LISTS.TITLE'), newButtonLabel: t('AUTOMATION.LISTS.NEW_LIST_BTN') }),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12 clearfix table-input search-section local-search-list" },
                react_1.default.createElement(SearchInput_1.default, { value: searchText, onChange: handleSearchInput, placeholder: t('AUTOMATION.LISTS.SEARCH_PLACEHOLDER') }),
                total > 0 && react_1.default.createElement(TablePagination_1.default, { totalCount: totalCount, limit: constants_1.limit, page: page, setPage: setPage }))),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12 empty-ng-table" },
                noData && (react_1.default.createElement(NoData_1.default, { href: createHref, title: t('AUTOMATION.LISTS.ERROR.NO_LIST_TEXT'), linkText: t('AUTOMATION.LISTS.ERROR.CREATE_LIST_LINK') })),
                noResults && (react_1.default.createElement(NoResults_1.default, { title: t('AUTOMATION.LISTS.ERROR.NO_LIST_MATCHED_TEXT'), linkText: t('AUTOMATION.LISTS.ERROR.RESET_CRITERIA_LINK'), linkClickHandler: function () { return setSearchText(''); } })),
                error && (react_1.default.createElement(HasError_1.default, { title: t('AUTOMATION.LISTS.ERROR.FETCH_UNABLE_TEXT'), btnText: t('AUTOMATION.LISTS.BTN.TRY_AGAIN'), btnHandler: function () { return dispatch((0, dictionarySlice_1.getDictionaries)({ domain: domain, kind: 'confusable,mixed' })); } })),
                total > 0 && (react_1.default.createElement("div", { className: "local-search-list" },
                    react_1.default.createElement(EvaTable_1.default, { data: filteredDictionaries, columns: constants_1.dictionariesColumns, limit: constants_1.limit, columnRenderer: columnRenderer, editHref: editHref, handleDelete: function (item) {
                            setSelectedDictionaryToRemove(item);
                            setIsModalOpen(true);
                        }, domain: domain, entity: "lists", currentUser: currentUser, defaultTableSorting: { nameSort: 'asc' }, page: page, setPage: setPage, tableClassName: "dictionariesTable" }))),
                isLoading && react_1.default.createElement(Loading_1.default, null))),
        react_1.default.createElement(ConfirmDelete_1.default, { onDelete: function () {
                if (!selectedDictionaryToRemove)
                    return;
                dispatch((0, dictionarySlice_1.deleteDictionary)({ domain: domain, name: selectedDictionaryToRemove.name }));
            }, isOpen: isModalOpen, setIsOpen: setIsModalOpen, title: t('AUTOMATION.LISTS.DELETE_POPOVER.TITLE'), text: t('AUTOMATION.LISTS.DELETE_POPOVER.TEXT_REACT', { listName: selectedDictionaryToRemove === null || selectedDictionaryToRemove === void 0 ? void 0 : selectedDictionaryToRemove.name }) })));
}
exports.default = default_1;
